import React, { useState, useRef, useEffect } from 'react';
import styles from './Gallery.module.scss';
import usePageVisible from '@hooks/usePageVisible';
import useWindowSize from '@hooks/useWindowSize';
import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';

export default function Gallery() {
  const [pageVisible, pageFocused] = usePageVisible();
  const [ref, inView] = useInView();
  const isPaused = !inView || !pageVisible || !pageFocused;

  return (
    <div
      ref={ref}
      className={classNames(styles.wrapper, {
        [styles.paused]: isPaused
      })}
    >
      <Row isPaused={isPaused} />
      <Row isPaused={isPaused} />
    </div>
  );
}

function Row({ isPaused }) {
  const ref = useRef();
  const [shouldClone, setShouldClone] = useState(true);
  const [hasInitialized, setHasInitialized] = useState(false);
  const [hasIterated, setHasIterated] = useState(false);
  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    // Don't animate if the window is wider than the row of images
    if (!isPaused || !hasInitialized) {
      setShouldClone(windowWidth < ref.current.offsetWidth - 60);
      setHasInitialized(true);
    }
  }, [windowWidth, isPaused, hasInitialized]);

  const content = (
    <React.Fragment>
      <div style={{ width: 300 }} />
      <div style={{ width: 350 }} />
      <div style={{ width: 280 }} />
      <div style={{ width: 400 }} />
      <div style={{ width: 300 }} />
      <div style={{ width: 220 }} />
      <div style={{ width: 280 }} />
    </React.Fragment>
  );

  return (
    <div
      className={classNames(styles.rowWrapper, {
        [styles.hidden]: !hasInitialized,
        [styles.disableAnimation]: !shouldClone
      })}
    >
      <div
        ref={ref}
        onAnimationIteration={() => setHasIterated(true)}
        className={classNames(styles.row, {
          [styles.iterated]: hasIterated
        })}
      >
        {content}
      </div>
      {shouldClone && <div className={styles.row}>{content}</div>}
    </div>
  );
}
